
import { useMongoAdd, useMongoDelete, useMongoUpdate } from "contexts/useMongoQuery";

const usePatientsMutations = () => {
  return {
    addPatient: useAddPatient(),
    deletePatient:  useDeletePatient(),
  };
}
export default usePatientsMutations

export const useUpdatePatient = (completed?: () => void) => {
  const [updateDataMutation, { error }] = useMongoUpdate("patients", false, {}, completed);
  const updateData = async (id: string | number, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error: Error | undefined }> => {
    const { data } = await updateDataMutation({ patientId: id }, set);
    const updatedData: { [key: string]: any } = data?.updatedData || {}
    return { updatedData: updatedData, error };
  };
  return updateData;
}

const useAddPatient = () => {
  const [addPatientMutation] = useMongoAdd("patients");
  const addPatient = async (patient: any) => {
    // @ts-ignore
    const { addedPatient } = await addPatientMutation({
      _id: Math.random().toString(36).substring(2, 10),
      created: new Date(),
      updated: new Date(),
      ...patient,
    });
    return addedPatient;
  };
  return addPatient;
}

const useDeletePatient = () => {
  const [deletePatientMutation] = useMongoDelete("patients");
  const deletePatient = async (patient: any) => {
    // @ts-ignore
    const deletePatient = await deletePatientMutation({ patientId: patient.patientId });
    return deletePatient;
  };
  return deletePatient;
}
